import { post, get } from 'src/helpers/api'
import { api } from '../api'
import {
  SET_GENERAL_RECEIPT_DATA,
  SET_RECEIPT_UPLOAD_DATA,
  SHOW_NOTIFICATION,
  SET_GENERAL_RECEIPT_LIST_DATA,
  SET_RECEIPT_RECEIPT_CANCELLATION_DATA,
} from 'src/store/types'

export const downloadReceiptTemplateFileAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.downloadTemplate, payload).then(response => {
      resolve(response.data)
    })
  })
}

export const setUploadReceiptDataAction = ({ commit }, payload) => {
  commit(SET_RECEIPT_UPLOAD_DATA, payload)
}

export const processReceiptTemplateFileAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.processTemplate, payload).then(response => {
      commit(SHOW_NOTIFICATION, { title: 'Success :', message: 'Operation Success', type: 'positive' })
      resolve(response.data)
    })
  })
}

export const saveGeneralReceiptAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.generalReceipt, payload)
      .then(response => {
        commit(SET_GENERAL_RECEIPT_DATA, response.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getGeneralReceiptByIdAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    get(api.generalReceipt + payload)
      .then(response => {
        commit(SET_GENERAL_RECEIPT_DATA, response.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const getGeneralReceiptListingAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    get(api.generalReceipt, payload)
      .then(response => {
        const json = response.data
        commit(SET_GENERAL_RECEIPT_LIST_DATA, {
          list: json,
        })
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const doGeneralReceiptCancellationAction = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    post(api.generalReceiptCancellation, payload)
      .then(response => {
        commit(SET_RECEIPT_RECEIPT_CANCELLATION_DATA, response.data)
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export const downloadGeneralReceiptAction = ({ commit }, payload) => {
  return new Promise(resolve => {
    post(api.generalReceiptDownload, payload).then(response => {
      resolve(response.data)
    })
  })
}
